import { SourceType } from './add-list-dialog.types';

export interface ValidationRule {
  isValid: (file: File | null) => boolean;
  errorMessage: string;
}

export const validationRules: ValidationRule[] = [
  {
    isValid: file => Boolean(file?.name),
    errorMessage: 'Please select a CSV file',
  },
];

export const validateForm = (file: File | null) => {
  return validationRules
    .map(rule => (rule.isValid(file) ? false : rule.errorMessage))
    .filter((error): error is string => Boolean(error));
};
